import React from "react";
import { Navbar } from "../Navbar";
import { Header } from "../Header";

export const MainLayout = ({ children, bgImage, bgVideo, text1, text2, text3, button }) => {
    return (
        <>
            <Navbar />
            <Header
                bgImage={bgImage}
                bgVideo={bgVideo}
                text1={text1}
                text2={text2}
                text3={text3}
                button={button}
            />
            {children}
        </>
    )
}